import React from 'react';

import { IReceita } from '../../hooks/receita';

import {
  Container,
  Section,
  SectionTitle,
  ObservacoesSection,
  SignatureSection,
  SignatureLine,
  SignatureInfo,
  ControladoBadge,
  Label,
  Separador,
  MedicamentObservation,
  BuyerContent,
  WaterMark,
} from './styles';

import Paciente from './paciente';

interface Props {
  receita: IReceita;
}

const Receita: React.FC<Props> = ({ receita }) => {
  const medicamentosOrdenados = [...(receita.medicamentos || [])].sort((a, b) =>
    a.created_at > b.created_at ? 1 : -1,
  );

  return (
    <>
      {receita.RecStatus !== 'Emitida' && (
        <WaterMark>
          <div
            style={{
              width: '100%',
              height: '90%',
              display: 'grid',
              placeItems: 'center',
              gap: '1rem',
              transform:
                'translate(0, 0) rotate(345deg) skewX(0) skewY(0) scaleX(1) scaleY(1)',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            }}
          >
            {Array.from({ length: 6 }).map((_, index) => (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={`ind-${index}`}
                className="text-4xl font-bold text-gray-400 whitespace-nowrap"
              >
                Pré Receita
              </span>
            ))}
          </div>
        </WaterMark>
      )}
      <Container>
        {/* <BarraTop /> */}
        <div style={{ padding: '0 10mm' }}>
          <Paciente receita={receita} />
        </div>
        <Section>
          <SectionTitle>MEDICAMENTOS PRESCRITOS</SectionTitle>
          {medicamentosOrdenados.length === 0 ? (
            <p className="text-center text-muted">
              Nenhum medicamento prescrito
            </p>
          ) : (
            <>
              {medicamentosOrdenados.map(med => (
                <div key={`medicamento-${med.MedCodigo}`}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '20px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Label>{med.MedNome}</Label>
                    <Label>{med.MedQuantidade}</Label>
                  </div>
                  <p>
                    <MedicamentObservation>
                      {med.MedObservacao || '-'}
                    </MedicamentObservation>{' '}
                    {med.MedControlado && (
                      <ControladoBadge controlado={med.MedControlado}>
                        Controlado
                      </ControladoBadge>
                    )}
                  </p>
                  <Separador />
                </div>
              ))}
            </>
          )}

          {receita.RecInformacao && (
            <ObservacoesSection>
              <SectionTitle>OBSERVAÇÕES GERAIS</SectionTitle>
              <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
                {receita.RecInformacao}
              </p>
            </ObservacoesSection>
          )}
        </Section>

        <SignatureSection>
          {receita.RecControlado && (
            <BuyerContent>
              <div>
                <p className="text-center">IDENTIFICAÇÃO DO COMPRADOR</p>
                Nome ___________________________________
                <br /> RG ____________________ Org. Em _________
                <br />
                Endereço ________________________________
                ________________________________________
                <br />
                Cidade _________________________ UF _____
                <br />
                Telefone _________________________
              </div>
              <div>
                <p className="text-center">IDENTIFICAÇÃO DO FORNECEDOR</p>
                <br />
                <br />
                <br />
                <br />
                ____________________________&nbsp;&nbsp;&nbsp; ___/___/______
                <br /> ASSINATURA FARMACÊUTICO
              </div>
            </BuyerContent>
          )}
          <SignatureLine />
          <SignatureInfo>
            {receita.RecUsuNome}
            {receita.RecUsuCRM && <span>CRM: {receita.RecUsuCRM}</span>}
          </SignatureInfo>
          <p style={{ marginTop: '10px' }}>{receita.RecUsuEndereco || '-'}</p>
          {/* <div
            style={{
              width: '100%',
              height: '45px',
              backgroundColor: 'rgb(19 178 189)',
              backgroundImage: `url(${logo})`,
              backgroundRepeat: 'repeat-x',
              backgroundSize: '150px',
              backgroundPositionY: '50%',
              backgroundBlendMode: 'soft-light',
            }}
          /> */}
        </SignatureSection>
      </Container>
    </>
  );
};

export default Receita;
